export default __webpack_public_path__ + "static/wlosinski-5e29f07be968e98dc39b2d85b8dcb744.png";